class UrlsService {
    public startDate: string = '';
    public endDate: string = '';
    public comparison: number = 1;

    public login(): string {
        return "/login"
    }

    public app(): string {
        return "/"
    }

    public dashboard(): string {
        return '/dashboard'
    }

    public dashboardExplorer(): string {
        return '/dashboard/explorer'
    }

    public dashboardPublishers(): string {
        return '/dashboard/publishers'
    }

    public dashboardPublisher(value?: string): string {
        return value
            ? `/dashboard/publishers/${encodeURIComponent(value)}`
            : '/dashboard/publishers/:publisher'
    }

    public reporting(): string {
        return '/reporting'
    }

    public campaigns(): string {
        return '/campaigns'
    }

    public accessManager(): string {
        return '/access-manager'
    }

    public apiKeys(): string {
        return '/api-keys'
    }

    public advancedTargeting(): string {
        return '/advanced-targeting'
    }

    public predictionAccuracy(): string {
        return '/prediction-accuracy'
    }

    public conversionUploads(): string {
        return '/conversion-uploads'
    }

    public conversionUploadBatch(id?: string): string {
        return id ? `/conversion-uploads/${id}` : '/conversion-uploads/:id'
    }

    public campaignNew(): string {
        return '/campaigns/new'
    }

    public campaignEdit(id?: string): string {
        return id ? `/campaigns/${id}/edit` : '/campaigns/:id/edit'
    }
}

const urlService = new UrlsService();

export { urlService };
